import {
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit'



const floorAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  //sortComparer: (a, b) =>   a.code.localeCompare(b.code)
})

const initialState = floorAdapter.getInitialState();


const floorSlice = createSlice({
  name: 'floor',
  initialState: initialState,
  reducers: {
    floorsSyncLoaded: {
      reducer(state, action) {
        floorAdapter.setAll(state, action.payload)
      },
       prepare(floorList) { 
         return {payload: floorList}
       }
    },
    clearFloors(state, action) {
      state.error=null
      state.status='idle'
      floorAdapter.removeAll(state)
    }


  }
})

export default floorSlice.reducer;

export const { floorsSyncLoaded, clearFloors } = floorSlice.actions

export const {
  selectAll:  selectAllFloors,
  selectById: xselectFloorById,
  selectIds:  selectFloorIds,
} = floorAdapter.getSelectors((state) => state.floor)


export const selectFloorById = (id)=>(state)=>xselectFloorById(state,id)

